angular.module('bfControllers.hollandSubbyers', []).controller(
    'HollandSubbuyersController',
    ['$scope', '$rootScope', '$http', '$resource', '$cookies', 'helpers',
        function ($scope, $rootScope, $http, $resource, $cookies, helpers) {
            this.dealsList = {};
            this.per_page = 10;
            $scope.pagination = new helpers.pagination(this.per_page, 30);

            $rootScope.sort = 'date';
            $rootScope.direct = 'desc';

            var self = this;

            /**
             * Get list of Subbuyer Deals
             * http://ec.term.biflorica:10000/api/Subbuyers/dealsList?page=1
             */
            this.getDeals = function () {
                $rootScope.querySent = true;
                $resource(API_LINK + '/:action',
                    {
                        action: 'Subbuyers/dealsList',
                        dates_range: $('.date-range-filter').val(),
                        page: $scope.pagination.currPage
                    },
                    {get: {method: 'GET'}}
                ).get(function (result) {
                    self.dealsList = result.data.list;
                    $scope.deals = result.data.list;
                    var count = parseInt(result.data.count_items);
                    var total = parseInt(result.data.total_items);
                    $scope.pagination.recountPages(count, total);
                    $rootScope.querySent = false;
                });
            };
            $rootScope.renewDeals = $scope.pagination.renewPage = this.getDeals;

            /**
             * Действия, которые необходимо выполнить после восстановления соединения с сервером ноды
             */
            $rootScope.$on('afterReconnect', function (event, data) {
                $rootScope.renewDeals();
            });

            // Действия после загрузки страницы
            this.getDeals();
        }]);
